import styled, { css } from 'styled-components'

export const Container = styled.div`
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.primitives.radius.radius2};
  display: flex;
  flex-direction: column;
`

export const HeaderList = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  background-color: ${props =>
    props.isParentSelected ? props.theme.colors.outline.default : props.theme.colors.text.inverse};
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  padding: ${props => `${props.theme.spacing.sp8} ${props.theme.spacing.sp8}`};

  svg {
    min-width: ${props => props.theme.size.S};
  }
`

export const ChildrenList = styled.div`
  background-color: ${props =>
    props.isParentSelected ? props.theme.colors.background.primary : props.theme.colors.disabled.surface};
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  padding: ${props => `${props.theme.spacing.sp8} ${props.theme.spacing.sp4}`};
`

export const ChildItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => `${props.theme.spacing.sp4} ${props.theme.spacing.sp4}`};
  border-radius: ${props => props.theme.primitives.radius.radius1};
  svg {
    min-width: ${props => props.theme.size.S};
  }

  ${props =>
    props.isParentSelected &&
    css`
      background-color: ${props => (props.isSelected ? 'rgba(0, 60, 70, 0.10)' : props.theme.colors.text.inverse)};
    `}
`
